import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrModalV2, {
  MODAL_THEME_FIXED_FOOTER_BUTTON,
} from 'client/components/SrModalV2/SrModalV2';
import {
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';

import './SrInfoTile.less';

export const SR_INFO_TILE_THEME_ADMIN_GREY = 'SR_INFO_TILE_THEME_ADMIN_GREY';
export const SR_INFO_TILE_THEME_ADMIN_LOGO = 'SR_INFO_TILE_THEME_ADMIN_LOGO';
const SR_INFO_TILE_THEME_TO_CLASSNAME_MAPPING = {
  [SR_INFO_TILE_THEME_ADMIN_GREY]: 'theme-admin-grey',
  [SR_INFO_TILE_THEME_ADMIN_LOGO]: 'theme-admin-logo',
};
const SR_INFO_TILE_THEMES = Object.keys(SR_INFO_TILE_THEME_TO_CLASSNAME_MAPPING);

export const SrInfoTileTextValue = ({
  children,
  color,
  cursor,
  theme,
}) => (
  <div
    className='SrInfoTileTextValue' // for cypress tests
    styleName={classnames(
      'value',
      SR_INFO_TILE_THEME_TO_CLASSNAME_MAPPING[theme],
    )}
    style={{
      cursor,
      color,
    }}
  >
    {children}
  </div>
);

const SrInfoTile = ({
  label,
  value,
  valueColor,
  photoUrls,
  editButtonLabel,
  onEditClick,
  theme,
  className,
}) => {
  const [showPhotosModal, setShowPhotosModal] = useState(false);
  const withPhotos = photoUrls && photoUrls.length > 0;

  const togglePhotosModal = () => {
    setShowPhotosModal(!showPhotosModal);
  };

  return (
    <div
      className={className}
      styleName={classnames(
        'SrInfoTile',
        SR_INFO_TILE_THEME_TO_CLASSNAME_MAPPING[theme],
        { withPhotos }
      )}
    >
      <div>
        <div styleName='topContainer'>
          <div styleName='label'>
            {label}
          </div>
          {editButtonLabel && onEditClick &&
            <div styleName='editButton' onClick={onEditClick}>
              {editButtonLabel}
            </div>
          }
        </div>
        <SrInfoTileTextValue
          color={valueColor}
          theme={theme}
        >
          {value}
        </SrInfoTileTextValue>
      </div>

      {withPhotos && (
        <div styleName='photoContainer' onClick={togglePhotosModal}>
          <img
            alt={label}
            src={photoUrls[0]}
            styleName='photo'
          />
        </div>
      )}

      {showPhotosModal && (
        <SrModalV2
          theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
          onClose={togglePhotosModal}
          buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
          showCloseButton
          overflow='auto'
        >
          <SrBox paddingBottom='80px'>
            {photoUrls.map((photo) => (
              <img
                key={photo}
                alt='unit'
                src={photo}
                width='100%'
                height='auto'
              />
            ))}
          </SrBox>
        </SrModalV2>
      )}
    </div>
  );
};

SrInfoTile.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  theme: PropTypes.oneOf(SR_INFO_TILE_THEMES),
  valueColor: PropTypes.string,
  editButtonLabel: PropTypes.string,
  onEditClick: PropTypes.func,
  className: PropTypes.string,
  photoUrls: PropTypes.array,
};

SrInfoTile.defaultProps = {
  editButtonLabel: 'Edit',
  valueColor: '#132630',
};

SrInfoTile.displayName = 'SrInfoTile';

export default SrInfoTile;
